var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C8.73478 0 8.48043 0.105357 8.29289 0.292893C8.10536 0.48043 8 0.734784 8 1V3H2C1.46957 3 0.960859 3.21071 0.585786 3.58579C0.210714 3.96086 0 4.46957 0 5V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V5C18 4.46957 17.7893 3.96086 17.4142 3.58579C17.0391 3.21071 16.5304 3 16 3H10V1C10 0.734784 9.89464 0.48043 9.70711 0.292893C9.51957 0.105357 9.26522 0 9 0ZM10 3V11.828L11.828 10C12.0155 9.81236 12.2699 9.70689 12.5351 9.7068C12.8004 9.7067 13.0549 9.81199 13.2425 9.9995C13.4301 10.187 13.5356 10.4414 13.5357 10.7066C13.5358 10.9719 13.4305 11.2264 13.243 11.414L9.883 14.773C9.64861 15.0072 9.33083 15.1387 8.9995 15.1387C8.66817 15.1387 8.35039 15.0072 8.116 14.773L4.757 11.414C4.66416 11.3211 4.59052 11.2108 4.5403 11.0894C4.49008 10.9681 4.46425 10.838 4.4643 10.7066C4.46434 10.5753 4.49026 10.4452 4.54057 10.3239C4.59088 10.2026 4.66459 10.0923 4.7575 9.9995C4.85041 9.90666 4.9607 9.83302 5.08207 9.7828C5.20343 9.73258 5.3335 9.70675 5.46485 9.7068C5.5962 9.70684 5.72626 9.73276 5.84759 9.78307C5.96892 9.83338 6.07916 9.90709 6.172 10L8 11.828V3H10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.418431ad782641d3168a432c1ffc4488.svg";
export { ForwardRef as ReactComponent };